<template>
    <b-form-group :label="label" :class="`${classFormGroupBind} `" :invalid-feedback="invalidFeedback"
        :description="descriptionField()" :state="error && error.$error ? false : null" style="font-size: 12px;">
        <b-input-group class="my-0 ">
            <b-input-group-prepend style="height: 20px; margin-top: -8px;">
                <slot name="prepend"> </slot>
            </b-input-group-prepend>

            <b-form-input :value="isStringValue ? value : value && value[fieldDescription]"
                @input="($value) => $emit('input', isStringValue ? $value : { ...value, [fieldDescription]: $value })"
                v-bind="$attrs" :disabled="disabled" :state="error && error.$error ? false : null"
                style="height: 20px; margin-top: -8px; font-size: 12px;"></b-form-input>

            <b-input-group-append v-if="showClearButton">
                <b-button @click="clear" variant="danger"
                    :disabled="!value || (!isStringValue && !value[fieldDescription]) || !showClear || disabled"
                    class="px-2" style="height: 20px; margin-top: -8px;">
                    X
                </b-button>
            </b-input-group-append>

            <b-input-group-prepend style="height: 20px; margin-top: -8px;">
                <slot name="comissao"> </slot>
            </b-input-group-prepend>

            <b-input-group-prepend style="height: 20px; margin-top: -8px; display: flex; align-items: center;">
                <slot name="incluirFilhos"> </slot>
            </b-input-group-prepend>

            <b-input-group-prepend style="height: 20px;   margin-top: -8px;">
                <slot name="notInUnidadeAdministrativa"> </slot>
            </b-input-group-prepend>

            <b-input-group-prepend style="height: 20px; margin-top: -8px;">
                <slot name="ornograma"> </slot>
            </b-input-group-prepend>


        </b-input-group>

    </b-form-group>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        cols: String,
        sm: String,
        md: String,
        fieldDescription: String,
        classFormGroup: {
            type: String,
            default: "",
        },
        label: String,
        value: [Object, String],
        invalidFeedback: {
            type: String,
            default: null,
        },
        description: {
            type: String,
            default: "Digite um valor válido",
        },
        error: {
            type: Object,
            default: null,
        },
        showClear: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        showClearButton: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        classFormGroupBind() {
            const responsiveCols =
                (this.cols !== undefined ? `col-${this.cols} ` : "") +
                (this.sm !== undefined ? `col-sm-${this.sm} ` : "") +
                (this.md !== undefined ? `col-md-${this.md} ` : "") || "col-12 ";
            return `${responsiveCols} ${this.classFormGroup}`;
        },
        isStringValue() {
            return typeof this.value === 'string';
        },
    },
    methods: {
        descriptionField() {
            if (this.$attrs.readonly) {
                return "Não editável";
            }
            return !this.error || !this.error.$error ? this.description : "";
        },
        async clear() {
            this.$emit("handleClean", {});
            this.$emit("input", this.isStringValue ? "" : {});
        },
    },
};
</script>

<style scoped>
/* Correção para alinhamento do slot incluirFilhos */
::v-deep .input-group-prepend .form-group {
    margin-bottom: 0 !important;
    display: flex !important;
    align-items: center !important;
    height: 20px !important;
}

::v-deep .input-group-prepend .form-group label {
    margin-bottom: 0 !important;
    margin-right: 8px !important;
    font-size: 12px !important;
    line-height: 1 !important;
}

::v-deep .input-group-prepend .form-group .form-check {
    margin-bottom: 0 !important;
    display: flex !important;
    align-items: center !important;
}

::v-deep .input-group-prepend .form-group .form-check-input {
    margin-top: 0 !important;
    margin-right: 4px !important;
}
</style>
